import React, { useState, useEffect, useRef, useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { debounce } from 'lodash';
import { Audio } from 'react-loader-spinner';
import { MdOutlineCancel } from 'react-icons/md';
import { IoMdAdd } from 'react-icons/io';
import { Layout, Header } from '../../../../components';
import { handleApi, formatMediumDate, formatCurrency } from '../../../../utils/utils';
import AppContext from '../../../../contexts/AppContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Departments = () => {
  const [departments, setDepartments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const { userData, currentColor } = useContext(AppContext);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const navigate = useNavigate();
  const itemsPerPage = 10;
  const dropdownRef = useRef(null);
  useEffect(() => {
    const timeout = setTimeout(() => fetchDepartments(), 500);
    return () => clearTimeout(timeout);
  }, [searchTerm]);

  useEffect(() => setCurrentPage(1), [searchTerm]);

  const fetchDepartments = async () => {
    const apiEndpoint = 'departments';
    setIsLoading(true);
    try {
      const response = await handleApi(apiEndpoint, {}, userData, 'GET', {});
      if (response.error) {
        toast.error(`Error: ${response.errorMessage}`);
        return;
      }
      console.log('response data sir',response.data)
      setDepartments(response.data);

    } catch (error) {
      toast.error(error.message || 'An unexpected error occurred.');
    } finally {setIsLoading(false);}
  };

  const handleSearchChange = (e) => setSearchTerm(e.target.value);
  const debouncedSearchTerm = useMemo(() => debounce(handleSearchChange, 300), []);

  const filteredDepartments = useMemo(() => {
    return departments.filter((dept) =>
        dept?.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [departments, searchTerm]);

  const sortedFilteredDepartments = filteredDepartments.sort(
    (a, b) => new Date(b.create_time) - new Date(a.create_time)
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const currentItems = sortedFilteredDepartments.slice(indexOfLastItem - itemsPerPage, indexOfLastItem);
  const totalPages = Math.ceil(filteredDepartments.length / itemsPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const handleClose = () => navigate(-1);

  const handleAction = (action, department) => {
    switch (action) {
      case 'new':
        navigate(`/Departments/new`, { state: { department: department } });
        break;
      case 'view':
        navigate(`/Departments/view/${department.id}`, { state: { department: department } });
        break;
      case 'edit':
        navigate(`/Departments/edit/${department.id}`, { state: { department: department } });
        break;
      case 'approve':
        navigate(`/Departments/approve/${department.id}`, { state: { department: department } });
        break;
      default:toast.error(`Action "${action}" is not supported.`);
    }
  };

  return (
    <Layout>
      <div className="m-2 sm:m-4 ">
        <h1 className='text-center font-bold'>DEPARTMENTS </h1>
        <ToastContainer position="top-center" autoClose={2000} />
        
        {isLoading ? (
          <div className="flex items-center flex-col py-6">
            <Audio height="80" width="80" radius="9" color={currentColor} ariaLabel="loading" />
            <p className="mt-2 text-white">Loading. Please wait...</p>
          </div>
        ) : (
         
          <div className="bg-white p-4 sm:p-6 my-6 mx-auto max-w-[50%] rounded-xl shadow-2xl">
            {/* Search Input */}
            <div className="mb-2 flex justify-between">
              <div className="relative w-full sm:w-1/2">
                {/* Emoji on the Left */}
                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-lg text-gray-500 select-none">🔍</span>

                {/* Input Field */}
                <input
                  type="text"
                  placeholder="Search department"
                  onChange={debouncedSearchTerm}
                  className="w-full py-2.5 pl-10 pr-4 rounded-xl bg-gray-200 text-gray-800 placeholder-gray-500 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-white transition duration-300 text-sm sm:text-base"
                />
              </div>
              {/* add new button */}
              <button
                className="text-white px-2 py-2 text-sm font-semibold rounded-lg flex items-center gap-1 bg-blue-500 hover:bg-blue-700 transition-all duration-300"
                onClick={() => handleAction('new', {})}
              >
                <IoMdAdd size={20} />
                <span>New Department</span>
              </button>
            </div>

            {/* Pagination */}
            {/* <div className="mt-3 flex flex-wrap gap-3 mb-4 justify-between items-center"> */}
              <div className="flex flex-wrap gap-1 my-2">
                {Array.from({ length: totalPages }).map((_, index) => (
                  <button
                    key={index + 1}
                    onClick={() => paginate(index + 1)}
                    className={`px-3 py-1 text-xs text-white rounded-full ${
                      currentPage === index + 1 ? 'bg-blue-700' : 'bg-blue-500'
                    }`}
                  >
                    {index + 1}
                  </button>
                ))}
              </div>
            {/* </div> */}

            {/* Table Display */}
            <div className="min-w-[300px] grid grid-cols-[15px_150px_150px] gap-6 px-4 py-3 bg-gradient-to-r from-gray-600 via-gray-500 to-gray-600 text-white rounded-t-xl shadow-inner bdepartment-b bdepartment-gray-500 text-sm font-semibold tracking-wide">
                <div className="">#</div>
                <div className="">Department Name</div>
                <div className="">Department Head</div>


            </div>
            {console.log('Current Items for display sir :', currentItems)}
            {currentItems.map((department) => (
              <div key={department.id} className="relative">
                {/* Table Row */}
                <div
                  onClick={() => setSelectedRowId(department.id === selectedRowId ? null : department.id)}
                  className="min-w-[300px] grid grid-cols-[15px_150px_150px] gap-6 px-4 pb-2 bdepartment-b bdepartment-gray-400 bg-gray-500 hover:bg-gray-400 hover:shadow-lg hover:ring-1 hover:ring-blue-300/40 transition-all duration-200 cursor-pointer rounded-sm"
                >
                    <div className=" mt-2  text-sm text-gray-300">{department?.id || 'N/A'}</div>
                    <div className=" mt-2 text-sm  text-gray-300">{department?.name || 'N/A'}</div>
                    <div className=" mt-2 text-sm  text-gray-300">{department?.hod?.first_name || 'N/A'}  {department?.hod?.last_name || 'N/A'}</div> 

                    
                </div>
                {selectedRowId === department.id && (
                  <div ref={dropdownRef} className="absolute z-50 mt-1 right-4 sm:right-10 bg-gray-900/80 
                    backdrop-blur-md shadow-xl ring-1 ring-blue-500/20 bdepartment bdepartment-gray-700 rounded-xl p-2 w-48 
                    flex flex-col animate-fade-in-down"
                  >
                    {department.approved === 1 ? (
                      <button
                        onClick={() => {
                          setSelectedRowId(null);
                          handleAction('view', department);
                        }}
                        className="text-left px-4 py-2 text-sm hover:bg-gray-800 hover:text-yellow-400 transition duration-300 rounded-lg text-white"
                      >
                        👁️ View
                      </button>
                    ) : (
                      <>
                        <button
                          onClick={() => {
                            setSelectedRowId(null);
                            handleAction('edit', department);
                          }}
                          className="text-left px-4 py-2 text-sm hover:bg-gray-800 hover:text-blue-400 transition duration-300 rounded-t-lg text-white"
                        >
                          ✏️ Edit
                        </button>
                        <button
                          onClick={() => {
                            setSelectedRowId(null);
                            handleAction('view', department);
                          }}
                          className="text-left px-4 py-2 text-sm hover:bg-gray-800 hover:text-yellow-400 transition duration-300 text-white"
                        >
                          👁️ View
                        </button>
                        <div className="bdepartment-t bdepartment-white/20 my-1" />
                          <button
                            onClick={() => {
                              setSelectedRowId(null);
                              handleAction('approve', department);
                            }}
                            className="text-left px-4 py-2 text-sm hover:bg-gray-800 hover:text-green-400 transition duration-300 rounded-b-lg text-white"
                          >
                            ✅ Approve
                          </button>
                        {/* </div> */}
                      </>
                    )}
                  </div>
                )}
              </div>
            ))}          
          </div>
        )}
      </div>
    </Layout>
  );
};
export default Departments;